import React from "react";

export default function Location({ className }) {
  return (
    <svg
      width="40"
      height="40"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className={className}
    >
      <g>
        <path
          d="M256 112c-56.248 0-89.832 35.16-89.832 94.048 0 33.512 44.528 110.936 89.816 172.752 45.016-62.024 89.848-138.488 89.848-172.752C345.832 147.16 312.248 112 256 112zm-.096 134.344c-21.792 0-39.456-17.664-39.456-39.456s17.664-39.456 39.456-39.456 39.456 17.664 39.456 39.456-17.664 39.456-39.456 39.456z"
          fill="currentColor"
          opacity="1"
        ></path>
        <path
          d="M256 0C114.616 0 0 114.616 0 256s114.616 256 256 256 256-114.616 256-256S397.384 0 256 0zm14.992 412.32L256 432l-14.904-19.68c-10.968-14.336-106.928-142.448-106.928-206.272C134.168 129.48 181.96 80 256 80s121.832 49.48 121.832 126.048c0 63.728-95.968 191.84-106.84 206.272z"
          fill="currentColor"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}
